export var getDomain = function (hostname) {
    return hostname.slice(hostname.indexOf('.'));
};
